import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MovimentoEstoqueService, ProdutoUnidadeService, SubGrupoEstoqueService } from 'almoxarifado-lib';
import { BaseResourceRptComponent, Coluna, EddyAutoComplete, EspecieAlmoxarifado, FuncaoService, GlobalService, LoginContabil, ProdutoUnidade, SaldoEstoqueService, Setor, SetorService, SubGrupoEstoque } from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'app-saidas-rpt',
  templateUrl: './saidas-rpt.component.html'
})
export class RelatorioSaidaRptComponent extends BaseResourceRptComponent {

  // ========================================================================
  // ----------------------- DECLARAÇÃO DE VARIAVEIS ------------------------
  // ========================================================================

  @Input() visualizar: boolean = false;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();
  @Input() compraId: number = 0;

  public login: LoginContabil;
  protected datepipe: DatePipe;

  public ordenacao: { nome: string, coluna: any };
  public listaOrdenacao: { nome: string, coluna: string }[] = [];

  public data_inicial: Date;
  public data_final: Date;
  public setor: Setor;

  public geral: boolean = false;
  public geralEstoques: boolean = false;


  // public favorecido: Favorecido;
  // public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;

  public subGrupo: SubGrupoEstoque;
  public subGrupoAutoComplete: EddyAutoComplete<SubGrupoEstoque>;

  public especie: EspecieAlmoxarifado;
  public listEspecies: { id: EspecieAlmoxarifado, nome: string }[];
  public produtoUnAutoComplete: EddyAutoComplete<ProdutoUnidade>;
  public setorAutoComplete: EddyAutoComplete<Setor>;
  public produto_unidade: ProdutoUnidade

  // ========================================================================
  // ------------------------------ CONSTRUTOR ------------------------------
  // ========================================================================

  constructor(protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected saldoService: SaldoEstoqueService,
    private movimentoService: MovimentoEstoqueService,
    // private favorecidoService: FavorecidoService,
    private subGrupoService: SubGrupoEstoqueService,
    private produtoUnService: ProdutoUnidadeService,
    private setorService: SetorService) {
    super();
    this.datepipe = new DatePipe('pt');
    this.login = GlobalService.obterSessaoLogin();
  }

  // ========================================================================
  // -------------------------- MÉTODOS ABSTRAÍDOS --------------------------
  // ========================================================================

  protected afterInit(): void {
    this.orientacao = 'landscape';
    this.listEspecies = this.globalService.obterEspeciesAlmoxarifado('S');
    this.listaOrdenacao = this.obterColunasOrdenacoes();
    this.ordenacao = this.listaOrdenacao[0];
    this.carregarAutoCompletes();
  }

  protected carregarLista(): Promise<any[]> {
    if (!this.validar())
      return;

    return new Promise((resolve) => {
      this.movimentoService.saidaRpt(this.login.orgao.id, new FuncaoService().converteDataSQL(this.data_inicial), new FuncaoService().converteDataSQL(this.data_final), this.especie, this.produto_unidade ? this.produto_unidade.id : 0, (this.geralEstoques ? 'S' : 'N'), (this.geral ? 'S' : 'N'), this.subGrupo ? this.subGrupo.id : 0, this.login.setorAlmoxarifado.estoque.id, this.setor ? this.setor.estoques[0].id : 0, this.ordenacao.coluna === 'data_movimento' ? 'data_movimento' : 'setorAlmoxarifado', !this.geral && !this.setor ? this.login.setorAlmoxarifado.id : 0)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(lista => {
          if (this.produto_unidade) {
            lista.map(entrada => {
              entrada['valor_total_saida_item'] = entrada['quantidade'] * entrada['valor_unitario'];
              return entrada;
            });
            resolve(lista);
          } else if (this.subGrupo) {
            lista.map(entrada => {
              entrada['valor_total'] = entrada['quantidade'] * entrada['valor_unitario'];
            });
            resolve(lista);
          } else {
            resolve(lista);
          }
        }, (error) => toastr.error(this.funcaoService.obterMensagemErro(error)));
    });
  }

  protected tituloRelatorio(): string {
    let titulo: string
    if (this.produto_unidade) {
      const periodo_inicio = this.data_inicial.toLocaleDateString('pt-BR');
      const peridio_final = this.data_final.toLocaleDateString('pt-BR');
      titulo = `RELATÓRIO DE SAÍDAS DE MATERIAIS\n   Produto: ${this.produto_unidade.produto.codigo} - ${this.produto_unidade.produto.nome}  -  Período: ${periodo_inicio} - ${peridio_final} `;
    } else {
      titulo = `RELATÓRIO DE SAÍDAS DE MATERIAIS\n   ${this.subGrupo ? `Subgrupo: ${this.subGrupo.nome}` : ''}`;
    }
    return titulo
  }

  protected obterColunasRelatorio(): Coluna[] {
    const retorno: Coluna[] = []

    if (this.produto_unidade) {
      retorno.push({ titulo: 'Grupo Padrão', coluna: 'subgrupo', alignment: 'left', agrupar: true, bold: true, adicionaisBody: { border: [false, false, false, false] } });
      retorno.push({ titulo: 'DATA', coluna: 'data_movimento', alignment: 'center', });
      retorno.push({ titulo: 'SETOR', coluna: 'setor' });
      retorno.push({ titulo: 'DOCUMENTO', coluna: 'documento', alignment: 'center' });
      retorno.push({ titulo: 'RECEBEDOR', coluna: 'recebedor' });
      retorno.push({ titulo: 'ESPÉCIE', coluna: 'especie', alignment: 'center' });
      retorno.push({ titulo: 'QT.', coluna: 'quantidade', alignment: 'center', decimais: 4 });
      retorno.push({ titulo: 'VALOR UN.', coluna: 'valor_unitario', alignment: 'right', decimais: 2 });
      retorno.push({ titulo: 'VALOR TOTAL', coluna: 'valor_total_saida_item', alignment: 'right', decimais: 2 });
    } else if (this.subGrupo) {
      retorno.push({ titulo: 'Grupo Padrão', coluna: 'subgrupo', alignment: 'left', agrupar: true, bold: true, adicionaisBody: { border: [false, false, false, false] } });
      retorno.push({ titulo: 'DATA', coluna: 'data_movimento', alignment: 'center', });
      retorno.push({ titulo: 'CÓDIGO MATERIAL', coluna: 'codigo_material', alignment: 'center' });
      retorno.push({ titulo: 'MATERIAL', coluna: 'nome_material' });
      retorno.push({ titulo: 'UNIDADE', coluna: 'unidade', alignment: 'center' });
      retorno.push({ titulo: 'SETOR', coluna: 'setor' });
      retorno.push({ titulo: 'ESPÉCIE', coluna: 'especie', alignment: 'center' });
      retorno.push({ titulo: 'QT.', coluna: 'quantidade', alignment: 'center', decimais: 4 });
      retorno.push({ titulo: 'VALOR UN.', coluna: 'valor_unitario', alignment: 'right', decimais: 2 });
      retorno.push({ titulo: 'VALOR TOTAL', coluna: 'valor_total', alignment: 'right', decimais: 2 });
    } else {
      retorno.push({ titulo: 'Grupo Padrão', coluna: 'subgrupo', alignment: 'left', agrupar: true, bold: true, adicionaisBody: { border: [false, false, false, false] } });
      retorno.push({ titulo: 'DATA', coluna: 'data_movimento', alignment: 'center', });
      retorno.push({ titulo: 'SETOR', coluna: 'setor' });
      retorno.push({ titulo: 'DOCUMENTO', coluna: 'documento', alignment: 'center' });
      retorno.push({ titulo: 'RECEBEDOR', coluna: 'recebedor' });
      retorno.push({ titulo: 'ESPÉCIE', coluna: 'especie', alignment: 'center' });
      retorno.push({ titulo: 'QT.', coluna: 'quantidade', alignment: 'center', decimais: 4 });
      retorno.push({ titulo: 'VALOR', coluna: 'valor_total', alignment: 'right', decimais: 2 });
    }

    return retorno
  }

  protected larguraColunas(): (string | number)[] {
    let retorno = [];

    if (this.produto_unidade) {
      retorno = ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
    } else if (this.subGrupo) {
      retorno = ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
    } else {
      retorno = ['auto', '*', 'auto', '*', 'auto', 'auto', 'auto'];
    }

    return retorno;
  }

  protected totalizarColunas(): (string | {})[] {
    if (this.produto_unidade) {
      return [{ nome: 'qtde', abaixo: true }, { nome: 'valor_total_saida_item', abaixo: true }];
    } else {
      return [{ nome: 'qtde', abaixo: true }, { nome: 'valor_total', abaixo: true }];
    }
  }

  protected layout(): {} {
    return {
      padrao: {
        hLineWidth(i, node) {
          return 1;
        },
        vLineWidth(i) {
          return 1;
        },
        hLineColor(i) {
          return 'black';
        },
        paddingLeft(i) {
          return 3;
        },
        paddingRight(i, node) {
          return 3;
        }
      }
    };
  }

  protected conteudoAdicional(lista): {}[] {
    const conteudo: any[] = [];

    conteudo.push([{ text: 'VALOR POR ESPÉCIE', colSpan: 2, alignment: 'center', bold: true, fontSize: 13 }, { text: '' }]);

    let especies: { descricao: string, valor: number }[] = [];
    let valor_total = 0;

    if (this.produto_unidade) {
      for (let movimento of lista) {
        let especie = especies.find((e) => e.descricao === movimento.especie);
        if (especie)
          especie.valor += +movimento.valor_total_saida_item;
        else
          especies.push({ descricao: movimento.especie, valor: +movimento.valor_total_saida_item })
        valor_total += +movimento.valor_total_saida_item;
      }

      for (let especie of especies) {
        if (conteudo.length === 1)
          conteudo.push([{
            text: [
              { text: this.globalService.tituloEspecieAlmoxarifado(<any>especie.descricao) + '  ', bold: true, fontSize: 13, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(especie.valor), fontSize: 12 }
            ]
          }, {
            text: [
              { text: 'TOTAL  ', bold: true, fontSize: 12, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(valor_total), fontSize: 12, margin: [10, 0] }
            ], rowSpan: especies.length
          }]);
        else
          conteudo.push([{
            text: [
              { text: this.globalService.tituloEspecieAlmoxarifado(<any>especie.descricao) + '  ', bold: true, fontSize: 12, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(especie.valor), fontSize: 12, margin: [10, 0] }
            ]
          }, { text: '' }]);
      }
    } else {
      for (let movimento of lista) {
        let especie = especies.find((e) => e.descricao === movimento.especie);
        if (especie)
          especie.valor += +movimento.valor_total;
        else
          especies.push({ descricao: movimento.especie, valor: +movimento.valor_total })
        valor_total += +movimento.valor_total;
      }

      for (let especie of especies) {
        if (conteudo.length === 1)
          conteudo.push([{
            text: [
              { text: this.globalService.tituloEspecieAlmoxarifado(<any>especie.descricao) + '  ', bold: true, fontSize: 13, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(especie.valor), fontSize: 12 }
            ]
          }, {
            text: [
              { text: 'TOTAL  ', bold: true, fontSize: 12, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(valor_total), fontSize: 12, margin: [10, 0] }
            ], rowSpan: especies.length
          }]);
        else
          conteudo.push([{
            text: [
              { text: this.globalService.tituloEspecieAlmoxarifado(<any>especie.descricao) + '  ', bold: true, fontSize: 12, alignment: 'center' }, { text: new FuncaoService().convertToBrNumber(especie.valor), fontSize: 12, margin: [10, 0] }
            ]
          }, { text: '' }]);
      }
    }

    return [{
      alignment: 'justify',
      columns: [{
        layout: 'linhas',
        table: {
          dontBreakRows: true,
          widths: ['*', '*'],
          body: conteudo
        }
      }, { text: '' }]
    }];
  }

  @HostListener('window:keydown.control.p', ['$event'])
  public abrirConsultaProduto(event: KeyboardEvent) {
    event.preventDefault();
    $('#dialogProdutoUnBuscaRelatorioSaida').modal('show');
  }

  public callbackProdutoUn(prodUn: ProdutoUnidade) {
    this.produto_unidade = prodUn;
  }

  // ========================================================================
  // -------------------------- MÉTODOS DA CLASSE ---------------------------
  // ========================================================================

  private carregarAutoCompletes() {
    this.produtoUnAutoComplete = new EddyAutoComplete(null, this.produtoUnService,
      'id', ['produto.codigo', 'produto.nome', 'unidade.nome'], { orderBy: 'produto.codigo,produto.nome', relations: ['produto.material.sub_grupo.grupo', 'unidade'] }, { number: ['id', 'produto.codigo'], text: ['produto.codigo', 'produto.nome', 'produto_codigo_comp'] },
      null, null, (entidade: ProdutoUnidade) => `${entidade.produto.material.sub_grupo.grupo.codigo}.${entidade.produto.material.sub_grupo.codigo}.${entidade.produto.material.codigo}.${entidade.produto.codigo} - ${entidade.produto.nome}`
    );

    this.setorAutoComplete = new EddyAutoComplete(null, this.setorService,
      'id', ['codigo', 'nome'], { orgao_id: this.login.orgao.id, relations: 'orgao,estoques', orderBy: 'nome' }, { text: ['nome', 'codigo'] }
    );

    // this.favorecidoAutoComplete = new EddyAutoComplete(null, this.favorecidoService,
    //   'id', ['cpf_cnpj', 'nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['cpf_cnpj'], text: ['nome'] }
    // );

    this.subGrupoAutoComplete = new EddyAutoComplete(null, this.subGrupoService,
      'id', ['codigo', 'nome'], { 'orgao_id': this.login.orgao.id, relations: 'grupo', orderBy: 'grupo.codigo,codigo,nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
  }

  public obterColunasOrdenacoes(): { nome: string, coluna: string }[] {
    return [
      { coluna: 'data_movimento', nome: 'Data Movimento' },
      { coluna: 'setorAlmoxarifado.setor.nome', nome: 'Setor' },
    ];
  }

  private validar(): boolean {
    if (!this.data_final || !this.data_inicial) {
      toastr.warning('Informe o período de conferência de saída!');
      return false;
    }
    return true;
  }

  public onHide() {
    this.visualizar = false;
    this.visualizarChange.emit(this.visualizar);
  }

  public show() {
    this.visualizar = true;
    this.visualizarChange.emit(this.visualizar);
  }

}